import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePageMob from './Layouts/HomePageMob';
import { useDevice } from './hooks/DeviceContext';
import HomePageDesk from './Layouts/HomePageDesk';
import ArchivePage from './Layouts/ArchivePage';
import { analytics } from './firebase';

function App() {
  const { isMobile } = useDevice();

  return (
    <div className='App'>
      <BrowserRouter>
        <Routes>
          <Route path='/' element={isMobile ? <HomePageMob /> : <HomePageDesk />} />
          <Route path='/archive' element={<ArchivePage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
